<template>
  <div class="card card-carousel overflow-hidden h-100 p-0">
    <div
      id="carouselExampleCaptions"
      class="carousel slide h-100"
      data-bs-ride="carousel"
    >
      <div class="carousel-inner border-radius-lg h-100">
        <!-- Slide 1: Featured Homes -->
        <div
          class="carousel-item h-100 active"
          :style="{
            backgroundImage:
              'url(' + require('@/assets/img/carousel-1.jpg') + ')',
            backgroundSize: 'cover',
          }"
        >
          <div class="carousel-caption d-none d-md-block bottom-0 text-start start-0 ms-5">
            
            <h5 class="text-white mb-1">Propiedades Destacadas</h5>
            <p>Explora casas únicas agregadas recientemente a nuestra plataforma.</p>
          </div>
        </div>

        <!-- Slide 2: Verified Agents -->
        <div
          class="carousel-item h-100"
          :style="{
            backgroundImage:
              'url(' + require('@/assets/img/carousel-2.jpg') + ')',
            backgroundSize: 'cover',
          }"
        >
          <div class="carousel-caption d-none d-md-block bottom-0 text-start start-0 ms-5">
            
            <h5 class="text-white mb-1">Agentes Verificados</h5>
            <p>Conecta con profesionales confiables para comprar o rentar propiedades.</p>
          </div>
        </div>

        <!-- Slide 3: Buyer Tips -->
        <div
          class="carousel-item h-100"
          :style="{
            backgroundImage:
              'url(' + require('@/assets/img/carousel-3.jpg') + ')',
            backgroundSize: 'cover',
          }"
        >
          <div class="carousel-caption d-none d-md-block bottom-0 text-start start-0 ms-5">
            
            <h5 class="text-white mb-1">Consejos para Compradores</h5>
            <p>Lee artículos útiles antes de tomar decisiones inmobiliarias importantes.</p>
          </div>
        </div>
      </div>

      <!-- Controls -->
      <button
        class="carousel-control-prev w-5 me-3"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Anterior</span>
      </button>
      <button
        class="carousel-control-next w-5 me-3"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Siguiente</span>
      </button>
    </div>
  </div>
</template>
